// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import VueLazyload from 'vue-lazyload';
import filter from '../src/assets/js/filter';
import MetaInfo from 'vue-meta-info';

import 'jquery';
import 'assets/style/normalize.scss';
import 'assets/style/variable.scss';
import 'assets/style/common.scss';

Vue.use(VueLazyload);
Vue.use(MetaInfo);
Vue.use(filter);
Vue.config.productionTip = false;

Vue.prototype.$axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

axios.defaults.withCredentials = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js